import { gql } from '@apollo/client';
import { AdminLocationInfo } from '../fragments';

export default gql`
  query adminLocation($id: ID) {
    adminLocation(id: $id) {
      ...AdminLocationInfo
    }
  }
  ${AdminLocationInfo}
`;
